import { Box, Typography, Paper } from '@mui/material';
import styles from './ReportStats.module.scss';
import classNames from 'classnames/bind';
import { DocumentScannerIcon, LeadsIcon } from '~/assets/icons';
import { IInsights } from '~/utils/interface/report';

const cx = classNames.bind(styles);

interface ReportStatsProps {
  insights: IInsights | null;
}

const ReportStats = ({ insights }: ReportStatsProps) => {
  const stats = [
    {
      label: 'Total Revenue',
      value: `$${insights?.totalRevenue}`,
      change: '+12.5%',
      icon: <DocumentScannerIcon fontSize="large" />,
      positive: true,
      iconClass: '',
    },
    {
      label: 'Total Leads',
      value: insights?.totalLead,
      change: '+8.2%',
      icon: <LeadsIcon fontSize="large" />,
      positive: true,
      iconClass: 'leads',
    },
    {
      label: 'Avg Job Value',
      value: `$${insights?.averageJobValue}`,
      change: '+5.8%',
      icon: <DocumentScannerIcon fontSize="large" />,
      positive: true,
      iconClass: '',
    },
  ];
  return (
    <Box className={cx('stats-root')}>
      {stats.map((stat) => (
        <Paper key={stat.label} className={cx('stat-card')} elevation={3}>
          <Box className={cx('icon-box', stat.iconClass)}>{stat.icon}</Box>
          <Typography variant="h6" className={cx('stat-label')}>{stat.label}</Typography>
          <Typography variant="h4" className={cx('stat-value')}>{stat.value}</Typography>
        </Paper>
      ))}
    </Box>
  );
};


export default ReportStats;
